import { auth, googleProvider, signInWithPopup, processGoogleSignInFunction } from './firebase-config.js';

// Get references to UI elements
const userStatus = document.getElementById('userStatus');
const signOutButton = document.getElementById('sign-out-button');
const signInButton = document.getElementById('signInButton');

// Function to update the UI based on auth state (inspired by kibbutz design)
const updateUI = (user) => {
    if (user) {
        userStatus.textContent = `Signed in as: ${user.displayName || user.email}`;
        userStatus.classList.remove('signed-out');
        userStatus.classList.add('signed-in');
        signInButton.style.display = 'none'; // Hide Google button
        signOutButton.style.display = 'block'; // Show sign out button
    } else {
        userStatus.textContent = "Not signed in.";
        userStatus.classList.remove('signed-in');
        userStatus.classList.add('signed-out');
        signInButton.style.display = 'block'; // Show Google button
        signOutButton.style.display = 'none'; // Hide sign out button
    }
};

async function signInWithGoogle() {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user; // Firebase Authentication User object

    console.log("Firebase Auth signed in user:", user.displayName, user.email);
    const payload = {
      uid: user.uid,
      displayName: user.displayName,
      email: user.email,
    };
    
    console.log("Client sending to Cloud Function:", payload);
    console.log("Payload validation:", {
      uid: !!payload.uid,
      displayName: !!payload.displayName,
      email: !!payload.email,
      uidType: typeof payload.uid,
      emailType: typeof payload.email
    });

    // Call your Cloud Function to process the sign-in and update Firestore
    const functionResult = await processGoogleSignInFunction(payload);

    console.log("Cloud Function response:", functionResult.data);
    const { status, message, userData, redirectUrl } = functionResult.data;

    if (status === 'user_exists') {
      console.log('Welcome back!', message);
    } else if (status === 'user_created') {
      console.log('Welcome to the app!', message);
    }

    // Handle redirect if provided by Cloud Function
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }

    // UI will be updated by onAuthStateChanged listener
  } catch (error) {
    if (error.code === 'auth/popup-closed-by-user') {
        console.warn("Sign-in popup closed by user.");
    } else if (error.code === 'functions/internal') {
        console.error("Error from Cloud Function:", error.message, error.details);
    } else {
        console.error("Error during sign-in process:", error.message);
    }
  }
}

// Sign Out functionality
async function signOutUser() {
    try {
        await auth.signOut();
        console.log("User signed out from Firebase.");
        // UI will be updated by onAuthStateChanged listener
    } catch (error) {
        console.error("Error signing out:", error.message);
    }
}

document.addEventListener('DOMContentLoaded', () => {
  // Add event listeners
  if (signInButton) {
    signInButton.addEventListener('click', signInWithGoogle);
  }
  
  if (signOutButton) {
    signOutButton.addEventListener('click', signOutUser);
  }

  // Firebase Auth State Listener (updates UI automatically)
  auth.onAuthStateChanged(user => {
    updateUI(user);
    if (user) {
      console.log("Auth state changed: User is signed in:", user.displayName);
    } else {
      console.log("Auth state changed: No user is signed in.");
    }
  });
});
